import { Heading, Box, Card, Flex, Button } from "theme-ui";

import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

import { COIN, GT } from "../../strings";

import { DisabledEditableRow, StaticRow } from "../Trove/Editor";
import { LoadingOverlay } from "../LoadingOverlay";
import { Icon } from "../Icon";

import { useStakingView } from "./context/StakingViewContext";
import { StakingGainsAction } from "./StakingGainsAction";

const select = ({ lqtyStake, totalStakedLQTY, sPrintBalance }: LiquityStoreState) => ({
  lqtyStake,
  totalStakedLQTY,
  sPrintBalance
});

export const ReadOnlyStake: React.FC = () => {
  const { changePending, dispatch } = useStakingView();
  const { lqtyStake, totalStakedLQTY, sPrintBalance } = useLiquitySelector(select);

  const poolShare = lqtyStake.stakedLQTY.mulDiv(100, totalStakedLQTY);

  const tokensPrice = JSON.parse(localStorage.getItem("tokensPrice") || "{}");
  const earnPrice = tokensPrice.PRINT || 0;

  return (
    <Card>
      <Heading>
        <div>
          <Icon style={{ marginRight: 10, color: "#00afff" }} name="database" />
          Liquid Staked PRINT (sPRINT)
        </div>
      </Heading>

      <Box sx={{ p: [2, 3] }}>
        <DisabledEditableRow
          label="Stake"
          inputId="stake-lqty"
          amount={sPrintBalance.prettify()}
          unit={"sPRINT"}
          usdVal={earnPrice.toString()}
        />

        <Flex variant="layout.actions">
          <Button
            variant="outline"
            onClick={() => dispatch({ type: "startAdjusting" })}
          >
            {/* <Icon name="pen" size="sm" /> */}
            &nbsp;Convert
          </Button>

          <Button
            variant="outline"
            onClick={() => dispatch({ type: "startRedeem" })}
          >
            {/* <Icon name="pen" size="sm" /> */}
            &nbsp;Redeem
          </Button>
        </Flex>
      </Box>

      {changePending && <LoadingOverlay />}
    </Card>
  );
};
